import config from "@/config";

export const NAV_IMAGE_ALLOWED_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
] as const;

export const NAV_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

export function validateNavImageFile(file: File): void {
  if (!NAV_IMAGE_ALLOWED_TYPES.includes(file.type as (typeof NAV_IMAGE_ALLOWED_TYPES)[number])) {
    throw new Error("Invalid file type. Allowed: JPEG, JPG, PNG, WebP.");
  }
  if (file.size > NAV_IMAGE_MAX_BYTES) {
    throw new Error("File is too large. Max size is 5 MB.");
  }
}

export function resolveNavImagePreviewUrl(
  url: string | null | undefined,
): string {
  if (!url) return "";
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith("//")) return trimmed;
  if (trimmed.startsWith("/")) {
    const base = config.apiUrl?.replace(/\/$/, "") ?? "";
    return base ? `${base}${trimmed}` : trimmed;
  }
  return trimmed;
}

export async function putFileToPresignedUrl(
  uploadUrl: string,
  file: File,
): Promise<void> {
  const putResponse = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
  if (!putResponse.ok) {
    throw new Error("Upload failed. Please try again.");
  }
}
